/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    fill="currentColor"
    fillRule="evenodd"
    d="M5.4698 17.4699a.75.75 0 1 1 1.0604-1.0609c0-.0001 0 .0001 0 0l4.7197 4.7197V.75a.75.75 0 0 1 1.5 0v20.3787l4.7198-4.7197a.75.75 0 0 1 1.0606 1.0607c.0002-.0002-.0002.0002 0 0L11.9999 24l-6.5301-6.5301Z"
    clipRule="evenodd"
  />,
  'ArrowDownLong'
);
